<!--公告  -->
<template>
  <div :class="['announcement',isFullScreen ? 'is-full-screen' : '']">
    <div class="list" v-for="(item,index) in noticeList" :key="index" v-show="noticeList.length">
       <span>{{ transformTime(Date.now()) }}</span>
        <p v-html="ReplaceUrl(item)"> </p>
    </div>
    <div class="noNotic" v-show="!noticeList.length">
      暂无公告
    </div>
  </div>

</template>

<script>
import { dateTime } from "../../../utils/tools";
export default {
  props:{
    isFullScreen:{
      type:Boolean,
      default: false
    }
  },
  data() {
    return {
      noticeList:[]//公告列表
    };
  },

  components: {},

  computed: {},

  mounted() {
    //显示公告
      DWLive.onAnnouncementShow = data => {
        // console.log('显示公告')
        this.noticeList = [data];
      }; 
      //修改公告
      DWLive.onAnnouncementRelease = data => {
        this.noticeList = [data];
      }; 
      // 删除公告
      DWLive.onAnnouncementRemove = data => {
        // console.log(2222,data)
      }; 
  },

  created() {},
  methods: {
     transformTime(time) {
      const t = dateTime(time);
      return `${t.year}.${t.month}.${t.day} ${t.h}:${t.m}`;
    },
    ReplaceUrl(text) {
      let re = /(http[s]?:\/\/([\w-]+.)+([:\d+])?(\/[\w-\.\/\?%&=]*)?)/gi;
      let s = text.replace(re,(u) => {
        return `<a target="_blank" style="color: #0091FF" href="${u}" target=_blank>${u}</a>`;
      });
      return s
    }
  },
};
</script>
<style lang="scss" scoped>
.announcement{
  padding: 40px;
  .list{
    margin: 0 0 24px 0;
    padding:24px 40px;
       background: #fff;
    border-radius: 16px;
 
    span{
      color: #787878;
      font-size: 28px;
    }
    p{
      padding: 16px 0 0 0;
      color: #333;
      font-size: 28px;
      line-height: 34px;
      word-break: break-all;
    }
  }
  .noNotic {
    width: 100%;
    height: 100px;
    font-size: 30px;
    line-height: 100px;
    text-align: center;
  }
}
.is-full-screen {
  padding: 20px;
  .list {
    padding: 15px;
  }
}
</style>
